import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';

import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import setTableCellType from 'utils/setTableCellType';

const InfoModal = (props) => {
  const { open, setOpen, data } = props;
  const { t } = useTranslation();

  const headCells = [
    { code: 'object_name', label: t('common.fields.objectName') },
    { code: 'debtsum', label: `${t('common.table.arrears')} (UZS)` },
    { code: 'debtval', label: `${t('common.table.arrears')} ($)` },
  ];
  const columns = [
    { code: 'object_name' },
    { code: 'debtsum', type: 'price' },
    { code: 'debtval', type: 'priceValute' },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const infoData = useMemo(() => {
    return data?.objects?.reduce((acc, item) => {
      return [
        ...acc,
        ...item?.debts?.map((debtItem) => ({
          ...debtItem,
          object_name: item?.object_name,
        })),
      ];
    }, []);
  }, [data?.objects]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!mb-5 text-center !bg-[#CDCDCDC7]'
      >
        <span>
          {t('boss.arrears.title')}:{' '}
          {moment(data?.date, 'YYYY-MM-DD').format('DD.MM.YYYY')}
        </span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper h-[calc(100vh-180px)]'>
          <TableContainer
            className='tab-table-container !shadow-none !base-border'
            component='div'
          >
            <Table stickyHeader component='div'>
              <TableHead component='div'>
                <TableRow component='div'>
                  {headCells?.map((cell, i) => (
                    <TableCell key={i} align={'left'}>
                      {cell?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {infoData?.length > 0 ? (
                <TableBody
                  className='overflow-hidden !bg-white'
                  component='div'
                >
                  {infoData?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={'row-' + rowIndex}
                        className='no-underline'
                        component={Link}
                        to={`/admin/contract/view/${row?.contract_id}`}
                      >
                        {columns.map((column, columnIndex) => (
                          <TableCell
                            align={'left'}
                            key={'column-' + columnIndex}
                          >
                            {column?.code == 'status'
                              ? t('boss.crm.general.active')
                              : column.type
                              ? setTableCellType(column, row[column.code], row)
                              : row[column.code]}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : (
                <TableBody component='div'>
                  <TableRow component='div'>
                    <TableCell colSpan={6}>
                      <span className='text-gray-400 flex items-center justify-center'>
                        <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                        {t('common.global.noDataFound')}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(InfoModal);
